function setStickyItem(id, model, table) {
  if (app.settingStickyItem == true) {
    return;
  }
  setStickyRequest(id, model, table);
}

function setStickyRequest(id, model, table) {
  const tooltipTextAdd = table == 'hashtags' ? 'Zu Top-Tags hinzufügen' : 'Als Topbeitrag auf der Startseite anzeigen';
  const tooltipTextRemove = table == 'hashtags' ? 'Von Top-Tags entfernen' : 'Von Startseite entfernen';

  const successTextAdd = table == 'hashtags' ? ' wurde zu Top-Tags hinzugefügt' : ' wird als Topbeitrag auf der Startseite angezeigt';
  const successTextRemove = table == 'hashtags' ? ' wurde von Top-Tags entfernt' : ' wurde von Top-Tags entfernt';

  $.ajax({
    url: '/admin/request/sticky',
    method: 'post',
    data: {
      id: id,
      model: model,
      table: table,
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.settingStickyItem = true;
    },
    success: function (response) {
      app.settingStickyItem = false;
      if (response && response.success) {
        $('.list-item__row--body[data-table="' + table + '"][data-id="' + id + '"]').attr(
          'data-sticky',
          response.sticky == 1 ? '1' : '0'
        );

        success(
          $('.list-items__wrapper').attr('data-name-single') + (response.sticky ? successTextAdd : successTextRemove)
        );

        if (
          app.tooltipRow &&
          (app.tooltipRow.content.html() == tooltipTextRemove ||
            app.tooltipRow.content.html() == tooltipTextAdd)
        ) {
          app.tooltipRow.setContent(response.sticky ? tooltipTextRemove : tooltipTextAdd);
        }
        return;
      }
      error();
    },
    error: function () {
      app.settingStickyItem = false;
      ajaxError();
    }
  });
}
